import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { task, timeout } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';
import { isEmpty, not } from 'ember-truth-helpers';

import { query } from 'umg-ember-backend/data/builders/umg-rest';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../select.module.css';

const bem = getBem(styles);

export default class ApplicationHeaderSelectArtist extends Component {
  // Services
  @service currentUser;
  @service filter;
  @service router;
  @service store;

  // Getter and setter
  get selectedArtist() {
    return this.filter.globalArtist;
  }

  // Functions
  setArtist = (model) => {
    this.filter.globalArtist = model;
    this.router.refresh();
  };

  searchArtists = task({ restartable: true }, async (term) => {
    await timeout(1000);

    const { content } = await this.store.request(
      query('artist', {
        'search[value]': term,
        'search[mode]': 'contains',
        'limit': 50,
      }),
    );

    return content.data ?? [];
  });

  // Template
  <template>
    <PowerSelect
      @allowClear={{true}}
      @disabled={{this.currentUser.hasOneArtist}}
      @loadingMessage={{t 'application.header.select_artist.loading_message'}}
      @onChange={{this.setArtist}}
      @placeholder={{t 'application.header.select_artist.placeholder'}}
      @searchMessage={{null}}
      @searchPlaceholder={{t
        'application.header.select_artist.search_placeholder'
      }}
      @renderInPlace={{true}}
      @search={{perform this.searchArtists}}
      @searchEnabled={{true}}
      @selected={{this.selectedArtist}}
      @triggerClass={{bem
        'trigger'
        (hash is-selected=(not (isEmpty this.selectedArtist)))
      }}
      @dropdownClass={{bem
        'dropdown'
        (hash is-selected=(not (isEmpty this.selectedArtist)))
      }}
      as |option|
    >
      {{option.displayLabel}}
    </PowerSelect>
  </template>
}
